import React from 'react'
import styles from "../../pages/pages.module.scss";
import "../../App.css";
import CardsComponent from './CardsComponent';
import { bannersData } from './data';

const CapitalBenefit = () => {
    return (
        <div className="bg-lighttheme">
            <section>
                <div className="container">
                    <div className="row">
                        <div className={`align-items-center d-flex flex-column ${styles.sectionheading}`}>
                            <h3>Access to capital <span>Benefit</span></h3>
                            <p className='col-xl-7'>Our AI-powered finance solution simplifies and enhances financial management through automation, predictive insights, and smart decision-making tools</p>
                        </div>
                    </div>
                    <div className="container mb-5">
                        <div className="banners">

                            <div className="m-0">
                                <CardsComponent {...bannersData[0]} />

                            </div>

                            <div className="gap-4 row row-gap-4 m-0">
                                <CardsComponent {...bannersData[1]} />
                                <CardsComponent {...bannersData[2]} />
                            </div>

                            <CardsComponent {...bannersData[3]} />
                        </div>
                    </div>

                    <div className={` ${styles.sectionheading} mt-lg-5`}>
                        <h3>Gain financial clarity and control</h3>
                        <p className='col-xl-7 mx-auto'> Financial summary delivered to you In-Time & on Demand: daily, weekly monthly All the information you need to stay on top of things at your finances/ stay on top of your finances</p>
                    </div>

                    <div className="container mb-lg-5 mb-3">
                        <div className="banners">
                            <div className="gap-4 row row-gap-4 m-0">
                                <CardsComponent {...bannersData[4]} />
                                <CardsComponent {...bannersData[5]} />
                            </div>
                        </div>
                    </div>
                </div>

            </section>
        </div>

    )
}

export default CapitalBenefit;